import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';

@Component({
  selector: 'ch-ngx-bootstrap-confirm',
  template:`
  <div class="confirm modal-body">
      <div class="content" [innerHTML]="title"></div>
      <div class="buttons">
          <button type="button" [ngClass]="confirmButtonClasses" (click)="confirm()" [innerHTML]="confirmLabel"></button>
          <button type="button" [ngClass]="declineButtonClasses" (click)="decline()" [innerHTML]="declineLabel"></button>
      </div>
  </div>
  `
})

export class NgxBootstrapConfirmComponent implements OnInit {
  public onClose: Subject<boolean>;
  title: string;
  confirmLabel: string;
  declineLabel: string;

  confirmButtonClasses = 'btn btn-success';
  declineButtonClasses = 'btn btn-danger';
  constructor(public bsModalRef: BsModalRef) {}

  public ngOnInit(): void {
    this.onClose = new Subject();
  }

  confirm() {
    this.onClose.next(true);
    this.bsModalRef.hide();
  }

  decline() {
    this.onClose.next(false);
    this.bsModalRef.hide();
  }
}
